import React, { useRef, useState } from 'react';
import { Carousel } from 'antd';
import about from '../../Assets/about.png';
import primary from '../../Assets/primary.jpg';
import highSchool from '../../Assets/HighSchool.jpg';
import intermediate from '../../Assets/intermediate.jpg';
import graduation from '../../Assets/graduation.jpg';

// import emoha from '../../Assets/emoha.png';



import './Journey.css';

export default function Journey() {
    const carouselRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);



    const handleNavigation = (index) => {
        if (carouselRef.current) {
            carouselRef.current.goTo(index);
        }
    };

    const [stages, setStages] = useState([
        {
            title: "Primary Education",
        },
        {
            title: "High School",
        },
        {
            title: "Intermediate",
        },
        {
            title: "Internship",
        },
        {
            title: "Resume",
        }
    ]);

    return (
        <div className='journey-container'>
            <div className='carousel-container'>
                <Carousel
                    ref={carouselRef}
                    dotPosition="left"
                    autoplay
                    autoplaySpeed={5000}
                    infinite={true}
                    afterChange={(index) => setCurrentSlide(index)}
                    arrows={true}
                >
                    <div className='containr' >
                        <img src={primary} alt="" className="image" />
                        <div className="text-overlay">
                            <p>
                                📚 Education Journey
                                <br />
                                🏫 Alok Shikshan Sansthan, Mahuapatan, Tarkulwa, Deoria
                                <br />
                                🏆 Class 8 – School Topper
                                <br />
                                🏅 Class 6 – Class Topper
                            </p>
                        </div>
                    </div>

                    <div className='containr'>
                        <img src={highSchool} alt="" className="image" />
                        <div className="text-overlay">
                            <p>
                                🎓 High School Education
                                <br />
                                🏫 Navtappi Inter College, Ranpur Garh
                                <br />
                                📖 Stream: Mathematics & Science
                                <br />
                                📊 Score: 84.6%

                            </p>
                        </div>
                    </div>

                    <div className='containr'>
                        <img src={intermediate} alt="" className="image" />
                        <div className="text-overlay">
                            <p>
                                🎓 Intermediate Education
                                <br />
                                🏫 Budha Inter College, Kushinagar
                                <br />
                                📖 Board Exam Score: 85%
                                <br />
                                🔢 Mathematics Score: 99 Marks
                                <br />
                                🏅 District Rank: 6th Place
                            </p>
                        </div>
                    </div>

                    <div className='containr'>
                        <img src={graduation} alt="" className="image" />
                        <div className="text-overlay" >
                            <p>
                                🎯 JEE Achievements & College Journey
                                <br />
                                📌 JEE Main & JEE Advanced Qualified (2021)
                                <br />
                                📊 JEE Main Percentile: 98.61%
                                <br />
                                🎓 Admitted to: NIT Jamshedpur
                                <br />
                                🏗️ Branch: Electronics & Communication Engineering
                                <br />
                                📖 Current CGPA: 8.49
                            </p>
                        </div>
                    </div>

                    <div className='containr' >
                        <img src={about} alt="" className="image" />
                        <div className="text-overlay" >
                            <p>
                                💻 Professional Experience
                                <br />
                                🚀 Software Intern at Emoha (Since Nov 4, 2024)
                                 <br />
                                💡 Learning  :
                                <br />
                                ⚛️ React.js & Redux – Building dynamic UI
                                <br />
                                🎨 Ant Design – Designing intuitive interfaces
                                <br />
                                🗄️ Sequelize & Node.js – Backend interactions
                                <br />
                                ⚡ API Optimization – Enhancing performance
                            </p>
                        </div>
                    </div>
                </Carousel>

            </div>

        </div>
    );
}
